import React, { useState, } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Hidden from '@material-ui/core/Hidden';

import Button from 'common/components/Button';
import Filters from './Filters';

const FiltersMobileView = () => {
    const [ isDrawerActive, setDrawerOpenState, ] = useState(false);
    const setDrawerOpenStateWrapper = (state: boolean) => () => setDrawerOpenState(state);

    return (
        <Hidden mdUp>
            <Box mt={2}>
                <Button onClick={setDrawerOpenStateWrapper(true)}>Filtry</Button>
            </Box>
            <SwipeableDrawer open={isDrawerActive}
                             onClose={setDrawerOpenStateWrapper(false)}
                             onOpen={setDrawerOpenStateWrapper(true)}>
                <Box width={250}>
                    <Box m={2}>
                        <Grid container
                              direction="row"
                              justify="space-between"
                              alignItems="center">
                            <Typography>FILTRY</Typography>
                            <CloseIcon onClick={setDrawerOpenStateWrapper(false)} />
                        </Grid>
                    </Box>
                    <Filters />
                </Box>
            </SwipeableDrawer>
        </Hidden>
    );
};

export default FiltersMobileView;
